export enum RangosEdadEnum {
    DE_00_A_18, DE_18_A_24, DE_25_A_34, DE_35_A_44, DE_45_A_54, DE_55_A_XX
}

const idsRangosEdad = new Map<RangosEdadEnum, string>();

idsRangosEdad.set(RangosEdadEnum.DE_00_A_18, "00_TO_18");
idsRangosEdad.set(RangosEdadEnum.DE_18_A_24, "18_TO_24");
idsRangosEdad.set(RangosEdadEnum.DE_25_A_34, "25_TO_34");
idsRangosEdad.set(RangosEdadEnum.DE_35_A_44, "35_TO_44");
idsRangosEdad.set(RangosEdadEnum.DE_45_A_54, "45_TO_54");
idsRangosEdad.set(RangosEdadEnum.DE_55_A_XX, "55_TO_XX");

const nombresRangosEdad = new Map<RangosEdadEnum, string>();

nombresRangosEdad.set(RangosEdadEnum.DE_00_A_18, "DE 00 A 18");
nombresRangosEdad.set(RangosEdadEnum.DE_18_A_24, "DE 18 A 24");
nombresRangosEdad.set(RangosEdadEnum.DE_25_A_34, "DE 25 A 34");
nombresRangosEdad.set(RangosEdadEnum.DE_35_A_44, "DE 35 A 44");
nombresRangosEdad.set(RangosEdadEnum.DE_45_A_54, "DE 45 A 54");
nombresRangosEdad.set(RangosEdadEnum.DE_55_A_XX, "DE 55 A XX");

export const obtenerIdRangoEdad: (rango: RangosEdadEnum) => string = rango => idsRangosEdad.get(rango) ?? "";
export const obtenerNombreRangoEdad: (rango: RangosEdadEnum) => string = rango => nombresRangosEdad.get(rango) ?? "";

export const obtenerIdsRangoEdad: () => Array<[RangosEdadEnum, string]> = () => Array.from(idsRangosEdad.entries());
export const obtenerNombresRangoEdad: () => Array<[RangosEdadEnum, string]> =
    () => Array.from(nombresRangosEdad.entries());
